"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "shrinkObjectSize", {
    enumerable: true,
    get: function() {
        return shrinkObjectSize;
    }
});
const _isplainobject = require("../is-plain-object");
const shrinkObjectSize = (obj, options = {})=>{
    const { maxKeys = Number.POSITIVE_INFINITY, maxDepth = Number.POSITIVE_INFINITY, currentDepth = 0 } = options;
    // Return empty object if we've exceeded max depth
    if (currentDepth >= maxDepth) {
        return {};
    }
    const entries = Object.entries(obj);
    const limitedEntries = entries.slice(0, maxKeys);
    return Object.fromEntries(limitedEntries.map(([key, value])=>{
        // Handle nested objects recursively
        if (value && (0, _isplainobject.isPlainObject)(value)) {
            return [
                key,
                shrinkObjectSize(value, {
                    maxKeys: maxKeys - limitedEntries.length,
                    maxDepth,
                    currentDepth: currentDepth + 1
                })
            ];
        }
        return [
            key,
            value
        ];
    }));
};
